var map = {
	"./articles-1.jpg": 796,
	"./articles-2.jpg": 25963,
	"./articles-3.jpg": 30126,
	"./articles-4.jpg": 83541,
	"./patient.jpg": 51524,
	"./patient.png": 2208,
	"./patient1.jpg": 22499,
	"./patient10.jpg": 93243,
	"./patient11.jpg": 73086,
	"./patient12.jpg": 64585,
	"./patient13.jpg": 66796,
	"./patient14.jpg": 27031,
	"./patient15.jpg": 58746,
	"./patient16.jpg": 32325,
	"./patient17.jpg": 88360,
	"./patient18.jpg": 58099,
	"./patient19.jpg": 29686,
	"./patient2.jpg": 76436,
	"./patient3.jpg": 64593,
	"./patient4.jpg": 79362,
	"./patient5.jpg": 71071,
	"./patient6.jpg": 3696,
	"./patient7.jpg": 48589,
	"./patient8.jpg": 33582,
	"./patient9.jpg": 11627
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97691;